import React from 'react';
import {TextField} from "@mui/material";

const Input = (props) => {

    return (
        <TextField
            id="outlined-basic"
            variant="outlined"
            sx={{width: '100%'}}
            {...props}
            color="secondary"
        />
    );
};

export default Input;